import { useContext } from 'react';

import { AppraisalContext } from './AppraisalContext';

export const useAppraisalContext = () => {
  const context = useContext(AppraisalContext);

  return context;
};
